export const CAMPAIGN_TEMPLATE_PARTICIPANTS = 1;
export const CAMPAIGN_TEMPLATE_TEAMS = 2;
export const CAMPAIGN_TEMPLATE_MIXED = 3;
export const CAMPAIGN_TEMPLATE_SOLO = 4;
